import { render, staticRenderFns } from "./TicketsDetail.vue?vue&type=template&id=c59bdadc&scoped=true&"
import script from "./TicketsDetail.vue?vue&type=script&lang=tsx&"
export * from "./TicketsDetail.vue?vue&type=script&lang=tsx&"
import style0 from "./TicketsDetail.vue?vue&type=style&index=0&id=c59bdadc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59bdadc",
  null
  
)

export default component.exports